module.exports = function() {
  return new Worker(__webpack_public_path__ + "d73be34a5a32f49a52b8.worker.js");
};